import React from 'react'

function PaymentStatus() {
  return (
    <div>
      PaymentStatus
    </div>
  )
}

export default PaymentStatus
